import { createFileRoute } from '@tanstack/react-router';

import { GeneralSettings } from '#modules/user/features/profile/components/GeneralSettings';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/general'
)({
  component: GeneralSettings,
  ssr: false,
});
